<template>
  <div
    :class="[
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: stateStoreInstance.open },
    ]"
    id="sidebar-area"
  >
    <div class="logo position-absolute start-0 end-0 top-0 bg-black">
      <router-link
        to="/"
        class="d-flex align-items-center text-white text-decoration-none"
      >
        <img
          :src="settingsStore.logo || require('../../assets/images/logo.png')"
          style="width: 80%; max-height: 44px; object-fit: fill;"
        />
      </router-link>
      <div class="border-bottom"></div>
      <button
        class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="stateStoreInstance.onChange"
      >
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul
        class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
        id="sidebarNavAccordion"
      >
        <li class="sidebar-nav-item">
          <router-link to="/" class="sidebar-nav-link d-block">
            <i class="flaticon-more-1"></i>
            <span class="title">Dashboard</span>
          </router-link>
        </li>

        <li
          v-if="canAny('/add-colis', '/colis-list', '/new-colis-list', '/import-colis')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseColis"
            aria-expanded="false"
            aria-controls="sidebarCollapseColis"
          >
            <i class="flaticon-sterile-box"></i>
            <span class="title">Colis</span>
          </a>
          <div
            id="sidebarCollapseColis"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="canRoute('/add-colis')">
                  <router-link to="/add-colis" class="sidebar-sub-menu-link">
                    Nouveau colis
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="canRoute('/colis-list')">
                  <router-link to="/colis-list" class="sidebar-sub-menu-link">
                    Liste des colis
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="canRoute('/new-colis-list')">
                  <router-link
                    to="/new-colis-list"
                    class="sidebar-sub-menu-link"
                  >
                    Colis pour ramassage
                  </router-link>
                </li>

                <li class="sidebar-sub-menu-item" v-if="canRoute('/import-colis')">
                  <router-link to="/import-colis" class="sidebar-sub-menu-link">
                    Importation colis
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="canAny('/products-list', '/colis-stock-list', '/add-colis-stock', '/import-colis-stock')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseStock"
            aria-expanded="false"
            aria-controls="sidebarCollapseStock"
          >
            <i class="flaticon-sterile-box"></i>
            <span class="title">Inventaire</span>
          </a>
          <div
            id="sidebarCollapseStock"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="canRoute('/products-list')">
                  <router-link
                    to="/products-list"
                    class="sidebar-sub-menu-link"
                  >
                    Liste des produits
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="canRoute('/colis-stock-list')">
                  <router-link
                    to="/colis-stock-list"
                    class="sidebar-sub-menu-link"
                  >
                    Colis de stock
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="canRoute('/add-colis-stock')">
                  <router-link
                    to="/add-colis-stock"
                    class="sidebar-sub-menu-link"
                  >
                    Nouveau colis
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="canRoute('/import-colis-stock')">
                  <router-link
                    to="/import-colis-stock"
                    class="sidebar-sub-menu-link"
                  >
                    Importation colis
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li
          v-if="canAny('/delivery-notes', '/add-delivery-note')"
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseBl"
            aria-expanded="false"
            aria-controls="sidebarCollapseBl"
          >
            <i class="flaticon-document"></i>
            <span class="title">Bons de livraison</span>
          </a>
          <div
            id="sidebarCollapseBl"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item" v-if="canRoute('/delivery-notes')">
                  <router-link
                    to="/delivery-notes"
                    class="sidebar-sub-menu-link"
                  >
                    Bons de livraison
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item" v-if="canRoute('/add-delivery-note')">
                  <router-link
                    to="/add-delivery-note"
                    class="sidebar-sub-menu-link"
                  >
                    Nouveau Bon de livraison
                  </router-link>
                </li>
                <!-- <li class="sidebar-sub-menu-item" >
                  <router-link to="/delivery-stock-notes" class="sidebar-sub-menu-link">
                    Bons de livraison stock
                  </router-link>
                </li> -->
              </ul>
            </div>
          </div>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/invoices-liste')">
          <router-link to="/invoices-liste" class="sidebar-nav-link d-block">
            <i class="flaticon-money"></i>
            <span class="title">Mes factures</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/return-client-liste')">
          <router-link
            to="/return-client-liste"
            class="sidebar-nav-link d-block"
          >
            <i class="flaticon-project"></i>
            <span class="title">Bons de retour</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/claims-list')">
          <router-link to="/claims-list" class="sidebar-nav-link d-block">
            <i class="flaticon-warning"></i>
            <span class="title">Réclamations</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/requests-pickup-list')">
          <router-link
            to="/requests-pickup-list"
            class="sidebar-nav-link d-block"
          >
            <i class="flaticon-ticket"></i>
            <span class="title">Ramassage</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/users-list')">
          <router-link to="/users-list" class="sidebar-nav-link d-block">
            <i class="flaticon-user-3"></i>
            <span class="title">Utilisateurs</span>
          </router-link>
        </li>

        <!-- <li
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapsePickup"
            aria-expanded="false"
            aria-controls="sidebarCollapsePickup"
          >
            <i class="flaticon-layer-2"></i>
            <span class="title">Ramassage</span>
          </a>
          <div
            id="sidebarCollapsePickup"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item">
                  <router-link to="/pickup-list" class="sidebar-sub-menu-link">
                    Bon de ramassage
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item">
                  <router-link to="/requests-pickup-list" class="sidebar-sub-menu-link">
                    Demandes de ramassages
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li> -->

        <li class="sidebar-nav-item" v-if="canRoute('/black-list')">
          <router-link to="/black-list" class="sidebar-nav-link d-block">
            <i class="flaticon-warning"></i>
            <span class="title">Black liste</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/documentation-api')">
          <router-link to="/documentation-api" class="sidebar-nav-link d-block">
            <i class="flaticon-settings"></i>
            <span class="title">Documentation API</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/documents')">
          <router-link to="/documents" class="sidebar-nav-link d-block">
            <i class="flaticon-document"></i>
            <span class="title">Mes documents</span>
          </router-link>
        </li>

        <li class="sidebar-nav-item" v-if="canRoute('/webhooks')">
          <router-link to="/webhooks" class="sidebar-nav-link d-block">
            <i class="flaticon-notification"></i>
            <span class="title">Webhooks</span>
          </router-link>
        </li>
        <!-- <li
          class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
        >
          <a
            href="#"
            class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapseOnlineStores"
            aria-expanded="false"
            aria-controls="sidebarCollapseOnlineStores"
          >
            <i class="flaticon-bag"></i>
            <span class="title">Stores en ligne</span>
          </a>
          <div
            id="sidebarCollapseOnlineStores"
            class="accordion-collapse collapse"
            data-bs-parent="#sidebarNavAccordion"
          >
            <div class="accordion-body">
              <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                <li class="sidebar-sub-menu-item">
                  <router-link to="/shopify" class="sidebar-sub-menu-link">
                    Shopify
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item">
                  <router-link to="/sheets" class="sidebar-sub-menu-link">
                    Google Sheets
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item">
                  <router-link to="/ColisConfirmed" class="sidebar-sub-menu-link">
                    Colis automatiques
                  </router-link>
                </li>
                <li class="sidebar-sub-menu-item">
                  <router-link to="/ColisErrones" class="sidebar-sub-menu-link">
                    Colis spam
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li> -->
        <li class="sidebar-nav-item">
          <router-link to="/account-settings" class="sidebar-nav-link d-block">
            <i class="flaticon-user"></i>
            <span class="title">Profile</span>
          </router-link>
        </li>

        <!-- <li class="sidebar-nav-item">
            <router-link to="/settings" class="sidebar-nav-link d-block">
              <i class="flaticon-settings"></i>
              <span class="title">Conditions Générales</span>
            </router-link>
          </li> -->

        <!-- <li class="sidebar-nav-item">
          <router-link to="/logout" class="sidebar-nav-link d-block">
            <i class="flaticon-logout"></i>
            <span class="title">Logout</span>
          </router-link>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import stateStore from "../../utils/store";
import { useAuthStore } from "@/stores/auth";
import { useSettingsStore } from "@/stores/settings";


export default defineComponent({
  name: "MainSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const auth = useAuthStore();
    // Settings are fetched by App.vue when the layout is shown.
    const settingsStore = useSettingsStore();
    const router = useRouter();

    // A menu item is visible iff the router guard would allow its route, so
    // the rules are declared once (route meta) and can't drift apart.
    function canRoute(path: string): boolean {
      return auth.canAccess(router.resolve(path).meta);
    }

    function canAny(...paths: string[]): boolean {
      return paths.some(canRoute);
    }

    function handleRouteClick() {
      if (stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }
    }

    return {
      stateStoreInstance,
      canRoute,
      canAny,
      handleRouteClick,
      settingsStore,
    };
  },
});
</script>